import { useState, useEffect, type KeyboardEvent } from 'react'

const COOKIE_CONSENT_KEY = 'pixorion_cookie_consent'
const COOKIE_CONSENT_MAX_AGE = 60 * 60 * 24 * 365

const hasConsentCookie = (): boolean => {
    return document.cookie.split('; ').some(cookie => cookie.startsWith(`${COOKIE_CONSENT_KEY}=`))
}

const setConsentCookie = (): void => {
    document.cookie = `${COOKIE_CONSENT_KEY}=accepted; max-age=${COOKIE_CONSENT_MAX_AGE}; path=/; SameSite=Lax`
}

export const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        if (!hasConsentCookie()) {
            setIsVisible(true)
        }
    }, [])

    const handleClose = () => {
        setConsentCookie()
        setIsVisible(false)
    }

    const handleCloseKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            handleClose()
        }
    }

    if (!isVisible) {
        return null
    }

    return (
        <>
            <style>{`
        @keyframes cookie-consent-in { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        .cookie-consent-anchor { position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%); width: 100%; max-width: 1100px; padding: 0 clamp(16px, 4vw, 24px); z-index: 9000; pointer-events: none; display: flex; justify-content: flex-end; box-sizing: border-box; }
        .cookie-consent { width: 100%; pointer-events: auto; animation: cookie-consent-in 0.5s ease; }
        @media (max-width: 1250px) { .cookie-consent { margin-right: 100px; } }
        .cookie-consent-card { background: rgba(13,10,18,0.95); backdrop-filter: blur(20px); border: 1px solid rgba(118,65,226,0.3); border-radius: 16px; padding: 20px 48px 20px 20px; box-shadow: 0 8px 32px rgba(0,0,0,0.5); position: relative; }
        .cookie-consent-text { color: #b8b3bd; font-size: 14px; line-height: 1.5; margin: 0; }
        .cookie-consent-close { position: absolute; top: 12px; right: 12px; width: 28px; height: 28px; border-radius: 999px; border: 1px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.05); color: #fff; font-size: 18px; line-height: 1; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: opacity 0.2s; }
        .cookie-consent-close:hover { opacity: 0.8; }
      `}</style>
            <div className='cookie-consent-anchor'>
                <div className='cookie-consent'>
                    <div className='cookie-consent-card'>
                        <p className='cookie-consent-text'>Для улучшения работы сайта мы используем файлы cookie</p>
                        <button
                            type='button'
                            className='cookie-consent-close'
                            onClick={handleClose}
                            onKeyDown={handleCloseKeyDown}
                            aria-label='Закрыть уведомление о cookie'
                        >
                            ×
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
